import React from "react";
import withTheme from "../../hoc/withTheme";

import Breadcrumbs from "../../components/layout/breadcrumbs/breadcrumbs.component";

const LayoutBreadcrumbs = ({ data }) => (
  <div className="container">
    <div className="row my-4">
      <div className="col-12">
        <Breadcrumbs data={data} />
      </div>
    </div>
  </div>
);

export default withTheme(LayoutBreadcrumbs);
